import SettingForm from './containers/Form';
import { SettingProvider } from './store';

export default function SettingLayout() {
  return <SettingProvider>
    <SettingForm />
  </SettingProvider>
}

